import React from "react";

const AuthHeader = () => {
	return (
		<nav>
			<a href="/">
				<img src="/logo_color.png" alt="osmo logo" height={80} />
			</a>
		</nav>
	);
};

export default AuthHeader;
